
import LogoSVG from "./logo.svg?react";
import SettingsSVG from "./settings.svg?react";
// import {ReactComponent as SearchSVG} from "./search.svg?react";
import CloseSVG from "./close.svg?react";
import ArrowSVG from "./arrow.svg?react";
import PlaySVG from "./play.svg?react";
import LargePlaySVG from "./play-large.svg?react";
import PauseSVG from "./pause.svg?react";
import BackwardSVG from "./backward.svg?react";
import ForwardSVG from "./forward.svg?react";
import CheckSVG from "./tick.svg?react";
import WarningSVG from "./warning.svg?react";
import SubtitlesSVG from "./subtitles.svg?react";
import FullscreenSVG from "./fullscreen.svg?react";
import ExitFullscreenSVG from "./exit-fullscreen.svg?react";
import VolumeSVG from "./volume-btn-white.svg?react";
import VolumeOffSVG from "./volume-off-btn-white.svg?react";
import LockSVG from "./lock.svg?react";
import DownloadSVG from "./download.svg?react";
import TvGuideSVG from "./tv-guide.svg?react";
import SignInSVG from "./sign-in.svg?react";
import PinkDownloadSVG from "./more/More-Downloads-Selected.svg?react";
import PinkTvGuideSVG from "./more/More-TV-Schedule-Selected.svg?react";
import PinkSignInSVG from "./more/More-Sign-In-Selected.svg?react";
import PinkDividerInSVG from "./pink-stoke.svg?react";
import ChevronLeftInSVG from "./chevron-left.svg?react";
import ChevronRightInSVG from "./chevron-right.svg?react";
import DisChevronLeftInSVG from "./chevron-left-disabled.svg?react";
import DisChevronRightInSVG from "./chevron-right-disabled.svg?react";
import LiveInSVG from "./live.svg?react";
import PlayButtonInSVG from "./play-button.svg?react";
import PinkPlayButtonInSVG from "./pink-playbutton.svg?react";
import LiveCbeebiesInSVG from "./channels/elongated/Live-CBeebies.svg?react";
import LiveEarthInSVG from "./channels/elongated/Live-Earth.svg?react";
import LiveLifestyleInSVG from "./channels/elongated/Live-Lifestyle.svg?react";
import CalenderInSVG from "./calender.svg?react";
import AudioSVG from "./audio.svg?react";
import SearchSVG from "./search.svg?react";


const SVG = {
    Logo:LogoSVG,
    Settings: SettingsSVG,
    SearchSVG,
    Close: CloseSVG,
    Arrow: ArrowSVG,
    Play: PlaySVG,
    LargePlay: LargePlaySVG,
    Pause: PauseSVG,
    BackwardSVG: BackwardSVG,
    ForwardSVG: ForwardSVG,
    Check: CheckSVG,
    Warning: WarningSVG,
    Subtitles: SubtitlesSVG,
    Fullscreen: FullscreenSVG,
    ExitFullscreen: ExitFullscreenSVG,
    Volume: VolumeSVG,
    VolumeOff: VolumeOffSVG,
    Lock: LockSVG,
    Download: DownloadSVG,
    TvGuide: TvGuideSVG,
    SignIn: SignInSVG,
    PinkTvGuide: PinkTvGuideSVG,
    PinkDownload: PinkDownloadSVG,
    PinkSignIn: PinkSignInSVG,
    PinkDivider: PinkDividerInSVG,
    ChevronRight: ChevronRightInSVG,
    ChevronLeft: ChevronLeftInSVG,
    Live: LiveInSVG,
    PlayButton: PlayButtonInSVG,
    PinkPlayButton: PinkPlayButtonInSVG,
    LiveCbeebies: LiveCbeebiesInSVG,
    LiveEarth: LiveEarthInSVG,
    LiveLifestyle: LiveLifestyleInSVG,
    DisChevronLeft: DisChevronLeftInSVG,
    DisChevronRight: DisChevronRightInSVG,
    Calender: CalenderInSVG,
    Audio: AudioSVG
  };

  export { SVG };
  